import { useIntl } from "react-intl";
import { AddOrUpdateContactProps } from "./types";
import { useCallback, useContext } from "react";
import { GlobalDialogContext } from "@/components/atoms/dialog/context";
import { PersonAddRegular, PersonEdit20Regular } from "@fluentui/react-icons";
import { Button } from "@fluentui/react-components";
import { Flex } from "@/components/atoms/flex";
import { AddOrUpdateContact } from "./AddOrUpdateContact";

export const AddOrUpdateContactButton = ({
	identifiedContact,
	interactionType,
	interactionId,
	onContactSaved,
}: AddOrUpdateContactProps) => {
	const intl = useIntl();

	const { showDialog, hideDialog } = useContext(GlobalDialogContext);

	const onAddOrUpdateClick = useCallback(() => {
		showDialog(
			intl.formatMessage({ id: "Contacts.AddOrUpdateContact" }),
			<AddOrUpdateContact
				interactionType={interactionType}
				interactionId={interactionId}
				identifiedContact={identifiedContact}
				onContactSaved={onContactSaved}
				onCloseDialog={() => hideDialog()}
			/>
		);
	}, [showDialog, identifiedContact]);

	return (
		<Flex>
			<Button
				appearance="primary"
				icon={identifiedContact.id ? <PersonAddRegular /> : <PersonEdit20Regular />}
				onClick={onAddOrUpdateClick}
			>
				{identifiedContact.id
					? intl.formatMessage({ id: "CustomerHistory.EditCustomer" })
					: intl.formatMessage({ id: "Contacts.AddOrUpdateContact" })}
			</Button>
		</Flex>
	);
};
